<template>
  <div class="iv-bg-w iv-main-width  iv-m-t-16" :style="{paddingTop: isFirst ? '24px' : '0'}">
    <div class="hr" v-if="menuList.length > 0"></div>
    <div class="iv-list-guide">
<!--      <div class="iv-list-left">-->
      <div class="iv-list-left" v-show="menuList.length > 0">
        <Row>
          <Col span="24">
            <Menu :theme="theme2"
                  :active-name="activeName"
                  ref="mainMenu">
              <template v-for="(item, index) in menuList">
                <Submenu :name="item.id" :key="item.id + '_' + index" v-if="item.children > 0">
                  <template slot="title">
                    {{ item.name }}
                  </template>
                  <Menu-item :name="i.id" v-for="(i) in item.children" :key="i.id" @click.native="select(i)">
                    {{ i.name }}
                  </Menu-item>
                </Submenu>
                <Menu-item :name="item.id" :key="item.id + '_' + index" @click.native="select(item)">{{ item.name }}
                </Menu-item>
              </template>
            </Menu>
          </Col>
        </Row>
      </div>
      <div class="iv-list-right" :class="menuList.length == 0 ? 'no-menu' : ''">
<!--        <right-views ref="rightViewRef" :type="righttype" :id="rightId" :name="name" @onloaded="onloaded" :haveLeft="true"></right-views>-->
        <right-views ref="rightViewRef" :type="righttype" :id="rightId" :name="name" @onloaded="onloaded" :haveLeft="menuList.length == 0?false:true" :categoryName ='$route.query.categoryName'></right-views>
      </div>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <!-- <router-view /> -->
  </div>
</template>

<script>
import rightViews from './model/dj-all.vue'

export default {
  data() {
    return {
      menuList: [],
      theme2: 'light',
      name: '',
      learnContent: '',
      categoryType: this.$route.query.categoryType,
      categoryCode: this.$route.query.categoryCode,
      subCategoryCode: this.$route.query.subCategoryCode,
      categoryName: this.$route.query.categoryName,
      activeName: this.$route.query.categoryId,
      spinShow: true,
      categoryId: this.$route.query.categoryId,
      isFirst: this.$route.query.isFirst,
      rightId: '1',
      righttype: '1',
      secondaryCategoryId: '', //需要直达的二级标题id
    }
  },
  created() {
    // this.initTabs()
    this.name = this.$route.query.categoryName
    this.secondaryCategoryId = this.$route.query.secondaryCategoryId
    this.initTabs()
  },
  watch: {
    '$route'(val) {
      console.log(val)
      if (val.name != 'newsDetail') {
        if (val.meta.title) {
          this.name = val.meta.title
        }else{
          this.name = this.$route.query.categoryName
        }
        this.initTabs()
      }
      this.categoryType = val.query.categoryType
      if (val.query.categoryId) {
        this.$refs.rightViewRef.initTabs(val.query.categoryId, 0)
      }
    }
  },
  methods: {
    onloaded() {
      this.spinShow = false
    },
    select(data) {
      this.activeName = data.id
      this.$nextTick(() => {
        this.$refs.mainMenu.updateActiveName()
      })
      this.rightId = data.id
      this.righttype = data.type
      this.$refs.rightViewRef.initTabs(data.id, data.type, 0)
      this.name = data.name
    },
    initTabs() {//查询栏目下二级栏目
      this.spinShow = true
      this.menuList = []
      this.$ajax({
        url: 'api-qixuan/cms/front/getColumn2List',
        method: 'get',
        data: {
          siteId:'95',//党群新闻站点id
          id: this.$route.query.categoryId,//上级栏目id
        }
      }).then(({data}) => {
        this.menuList = data.data
        this.name = this.$route.query.categoryName
        this.spinShow = false
        if (!this.categoryId && this.menuList.length > 0) {
          console.log('进来了！！！！！')
          this.$nextTick(() => {
            if (this.$route.name == 'systemIndex') {
              this.$refs.learnContent.initTabs(this.$route.query.categoryCode)
            } else {
              this.$refs.learnContent.initTabs(this.menuList[0].id)
            }
          })
        }
        this.$refs.mainMenu.currentActiveName = this.activeName
        this.$refs.mainMenu.openedNames = [this.activeName]
        this.$nextTick(() => {
          this.$refs.mainMenu.updateActiveName()
        })
        this.rightId = this.categoryId
        this.righttype = this.categoryType
        this.$nextTick(() => {
          if (this.secondaryCategoryId !== '') {
            this.menuList.map(item => {
              if (item.id == this.secondaryCategoryId) {
                this.select(item)
              }
            })
          }
        })
      })
    }
  },
  components: {
    rightViews
  }
}
</script>

<style lang="scss" scoped>
.iv-bg-w {
  background-color: white;
  height: 100%;
  position: relative;

  .hr {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1px;
    left: 23%;
    background: rgba(0, 0, 0, 0.15);
  }
}

.iv-list-guide {
  margin: 0 auto;
  width: 1200px;
  z-index: 0;
  margin-top: 24px;
  background: #FFFFFF;
  display: flex;

  .iv-list-left {
    //float: left;
    width: 23%;
    //width: 272px;

    /deep/ .ivu-row {
      width: 100% !important;

      .ivu-menu {
        z-index: 0;
        width: 100% !important;

        .ivu-menu-item {
          width: 100% !important;
          font-size: 16px;
          // color: rgba(0, 0, 0, 0.64);
          font-weight: bold;
          // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
        }

        .ivu-menu-submenu-title {
          width: 271px !important;
          font-size: 16px;
          // color: rgba(0, 0, 0, 0.64);
          font-weight: bold;
          // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
        }
      }

      .ivu-menu-item[class~=ivu-menu-item].ivu-menu-item-active[class~=ivu-menu-item-active] {
        // width: 1px;
        // height: 56px;
        // background: #2373C8;
        font-size: 16px;
        // color: rgba(0, 0, 0, 0.64);
        font-weight: bold;
        border-right: 2px solid rgba(104, 171, 243, 0.6);
        // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
        background: #F0FAFF;
      }

      .ivu-menu-item[class~=ivu-menu-item]:hover {
        background: #F0FAFF !important;
      }

      .ivu-menu-item[class~=ivu-menu-item].ivu-menu-item-active[class~=ivu-menu-item-active] {
        background: #F0FAFF !important;
      }
    }
  }

  .iv-list-right {
    // float: right;
    //margin-left: 296px;
    width: calc(77% - 24px);
    padding-right: 24px;
    margin-left: 24px;

    &.no-menu {
      width: 1200px;
      margin-left: 0;
      padding-left: 24px;

      ///deep/ .iv-list-right-cont {
      //  div {
      //    margin-right: 34px;
      //
      //    &:nth-of-type(4n) {
      //      //margin-right: 0px;
      //    }
      //  }
      //}
    }

    // .iv-list-right-title {
    //   height: 57px;
    //   font-size: 16px;
    //   color: #000000;
    //   line-height: 57px;
    //   border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    //   span {
    //     display: inline-block;
    //     height: 57px;
    //     line-height: 57px;
    //     border-bottom: 1px solid #2373C8;;
    //   }
    // }
  }

  /deep/ .iv-list-page {
    float: right;
    margin-top: 20px;
    padding-bottom: 28px;
  }
}
</style>